import React, { memo } from 'react'
import { Form, Field } from 'react-final-form'
import { Box, Button, CircularProgress, MenuItem } from '@mui/material'
import { useGetCompanyDomainsQuery } from '../../../../api/integrations'
import { useUpdateSamlProviderMutation } from '../../../../api/settings.api'
import useMutation from '../../../../hooks/useMutation'

import TextFieldAdapter from './TextFieldAdapter'
import { formStyles } from './styles'
import { validate } from './validationSchema'

const AdapterForm = memo(({ adapter, onClose }) => {
  const { data: domains = [], isLoading } = useGetCompanyDomainsQuery()
  const {
    submit: updateProvider,
    isLoading: isUpdating,
    error
  } = useMutation(useUpdateSamlProviderMutation, {
    onSuccess: () => onClose()
  })

  const handleSubmit = values => {
    updateProvider({
      id: adapter.id,
      domain: values.domain,
      entityId: values.entityId,
      idpUrl: values.idpUrl,
      certificate: values.certificate
    })
  }

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ certificate: adapter?.certificates?.[0]?.certificate, ...adapter }}
      validate={validate}
      render={({ handleSubmit, submitting, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Box sx={formStyles.form}>
            <Field
              name='spEntityId'
              label='Entity ID'
              component={TextFieldAdapter}
              disabled
              sx={{ ...formStyles.field, ...formStyles.readOnlyField }}
            />
            <Field
              name='spAssertionUrl'
              label='Assertion URL'
              component={TextFieldAdapter}
              disabled
              sx={{ ...formStyles.field, ...formStyles.readOnlyField }}
            />

            <Field name='domain' label='Domain' component={TextFieldAdapter} select sx={formStyles.field}>
              {isLoading ? (
                <CircularProgress size={20} />
              ) : (
                domains?.map(domain => (
                  <MenuItem key={domain?.domain} value={domain?.domain}>
                    {domain?.domain}
                  </MenuItem>
                ))
              )}
            </Field>
            <Field name='entityId' label='IdP Entity ID' component={TextFieldAdapter} sx={formStyles.field} />
            <Field name='idpUrl' label='IdP Login URL' component={TextFieldAdapter} sx={formStyles.field} />
            <Field
              name='certificate'
              label='Certificate'
              component={TextFieldAdapter}
              multiline
              rows={4}
              sx={formStyles.field}
            />
            {error && <Box sx={{ color: 'error.main', mb: 2 }}>{error.message || 'Failed to update provider'}</Box>}
            <Box sx={formStyles.actions}>
              <Button onClick={onClose} sx={formStyles.cancelButton} variant={'outlined'}>
                Cancel
              </Button>
              <Button
                type='submit'
                variant='contained'
                disabled={isUpdating || submitting || pristine}
                sx={formStyles.submitButton}
              >
                {isUpdating ? <CircularProgress size={20} /> : 'Save'}
              </Button>
            </Box>
          </Box>
        </form>
      )}
    />
  )
})

AdapterForm.displayName = 'AdapterForm'

export default AdapterForm
